import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'

Swiper.use([Navigation, Pagination])
Swiper.extendDefaults({ speed: 500 })

export const tariffsSwiper = new Swiper('[data-cloud-tariffs-swiper]', {
  slidesPerView: 'auto',
  pagination: {
    el: '[data-cloud-tariffs-progress-bar]',
    type: 'progressbar',
  },
  navigation: {
    nextEl: '[data-cloud-tariffs-next]',
    prevEl: '[data-cloud-tariffs-prev]',
  },
})

new Swiper('[data-cloud-pros-swiper]', {
  slidesPerView: 'auto',
  pagination: {
    el: '[data-cloud-pros-pagination]',
    type: 'progressbar',
  },
  navigation: {
    nextEl: '[data-cloud-pros-next]',
    prevEl: '[data-cloud-pros-prev]',
  },
  breakpoints: { 1024: {} },
  on: {
    breakpoint: function (swiper) {
      if (swiper.currentBreakpoint === '1024') {
        this.slideTo(0)
        this.disable()
      } else {
        this.enable()
      }
    },
  },
})
